var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loggedIn)?_c('p',{staticClass:"text-small contact__loggedin"},[_vm._v(" Angemeldet als: "+_vm._s(_vm.username)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }